import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Box, Typography } from "@mui/material";
import { appdata } from "../models/appdata";

const CarouselPart = () => {
  return (
    <Carousel autoPlay={true} infiniteLoop showThumbs={false}>
      {appdata.carouselData.map((v, i) => (
        <CarouselItem key={i} data={v} />
      ))}
    </Carousel>
  );
};

export default CarouselPart;

const CarouselItem = ({ data }) => (
  <Box component="div">
    <Box component="img" src={data.image} />
    <Typography component="p" className="legend">
      {data.keterangan}
    </Typography>
  </Box>
);
